import React, {Component} from 'react';
import {PRIMARY_GRAY} from "../constants/COLORS";
import styled from "styled-components"
import {GoogleMap, LoadScript, Marker} from '@react-google-maps/api';
import NavigateToCoordsButton from "./NavigateToCoordsButton";
import {CallerCardBase} from "./CalllerCardBase";


const Card = styled(CallerCardBase)`

min-height: 750px;
height: auto;

.textContent{
    height: 250px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    table{
      width: 85%;
      display: block;
      margin: 2.5rem auto;
      thead{
          font-size: 1.1rem;
          font-weight: 600;
          td{
          padding: 0 0 1.1rem;

          }
      }
      tbody{
          font-size: 1.3rem;
          font-weight: 400;
      }
      td{
      word-break: break-word;
      padding-left: 1rem;
      vertical-align: top;
      }
      td:first-child{
              width: 60%;

      }
      td:last-child{
              width: 40%;
              font-size: 1rem;

      }
  }
    @media only screen and (max-width: 500px){
        height: auto;
        min-height: 150px;
        position: relative;
        table{
          margin: 1rem;
        }
        thead{
          display: none !important;
        }
        tbody,tr{
            width: 100% !important;
        }
        td{
            width: 100% !important;
            display: block !important;
            font-size: 1.2rem;
        }
    }
  }
@media only screen and (max-width: 500px){
    button{
      display: block;
      padding: 0.5rem  !important;
      margin: 0 auto !important;
      width: 90% !important;
      right: auto;
      bottom: auto;
      position: relative;
    }
}
  
   
`

class CallerLocationDataCard extends Component {

    render() {
        const {data} = this.props
        return (
            <Card>
                <LoadScript
                    googleMapsApiKey="AIzaSyArAZSgfZJcC_KiXv4s_WAUPhJnyA8De8s"
                    language={'hu'}
                >
                    <GoogleMap
                        mapContainerStyle={{width: '100%', height: 500}}
                        center={{lat: data.lat, lng: data.lng}}
                        zoom={14}
                        options={{
                            streetViewControl: false,
                            mapTypeControl: false,
                            fullscreenControl: false,
                            clickableIcons: false,
                            zoomControl: true,
                            mapId: '22a4356b17a795ab'
                        }}
                    >
                        <></>
                        <Marker
                            position={{
                                lat: data.lat,
                                lng: data.lng,
                            }}/>
                    </GoogleMap>
                </LoadScript>
                <div className="textContent">
                    <table>
                        <thead>
                            <tr>
                                <td>cim:</td>
                                <td>koordinata:</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{data.address.formatted_address}</td>
                                <td>{data.lat}<br/>{data.lng}</td>
                            </tr>
                        </tbody>
                    </table>
                    <NavigateToCoordsButton lat={data.lat} lng={data.lng}/>
                </div>
            </Card>
        );
    }
}

export default CallerLocationDataCard;